package one.healthium.content.navigation.insights

import com.arkivanov.decompose.ComponentContext
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ActionModel.Category
import one.healthium.insights.domain.models.ActionModel.Insight
import one.healthium.insights.domain.models.ActionModel.MealPlan
import one.healthium.insights.domain.models.ActionModel.Recipe
import one.healthium.insights.domain.models.ActionModel.Workout

class DefaultInsightsComponent(
    componentContext: ComponentContext,
    private val onActionClicked: (ActionModel) -> Unit,
) : InsightsComponent, ComponentContext by componentContext {
    override fun onActionClicked(action: ActionModel) {
        onActionClicked.invoke(action)
    }

    override fun onContentClicked(options: ContentOptions) {
        when (options) {
            is ContentOptions.Insight -> onActionClicked(
                Insight(options.id)
            )

            is ContentOptions.Recipe -> onActionClicked(
                Recipe(options.id)
            )

            is ContentOptions.MealPlan -> onActionClicked(
                MealPlan(options.id)
            )

            is ContentOptions.Workout -> onActionClicked(
                Workout(options.id)
            )

            is ContentOptions.Category -> onActionClicked(
                Category(options.id)
            )
        }
    }
}